<template>
    <div v-if="this.visible">



  <FormKit
    type="number"
    label="Delegados a elegir"
    v-model="delegados"
    validation=required|min:1
    validation-visibility="live"

  />
  <FormKit
    type="number"
    label="Votos emitidos"
    v-model="votos_emitidos"
    validation=required|min:1
    validation-visibility="live"
  />

  <FormKit
    type="number"
    label="Votos en blanco"
    v-model="votos_blanco"
    validation=required|min:0
    validation-visibility="live"
  />
  <FormKit
    type="number"
    label="Votos nulos"
    v-model="votos_nulos"
    validation=required|min:0
    validation-visibility="live"
  />

CANDIDATURAS

<div v-for="(candidatura, index) in candidaturas">
<div class="wrapperin">
    <FormKit
    type="text"
    help="Sindicato"
    v-model="candidatura.sindicato"
    validation=required
    validation-visibility="live"
  />

    <FormKit
    type="number"
    help="votos"
    v-model="candidatura.votos"
    validation=required|min:0
    validation-visibility="live"
  />

  <FormKit
    type="button"
    @click="deleteCandidatura(index)">

  <span class="fa fa-trash" aria-hidden="true"></span>
  </FormKit>


</div>
 </div>




        <FormKit
    type="button"
    @click="addCandidatura">
    Añadir candidatura
  </FormKit>


  <FormKit
    type="button"
    @click="calculaResultados"
    >
    Contabilizar Resultados

  </FormKit>



</div>

<div v-else-if="this.visible == 0">
  <div class="row">
    <div class="col-12">
      <h4>
       RECUENTO ELECTORAL</h4>
    </div>

  </div>
   <div class="row invoice-info">
    <div class="col-sm-6 invoice-col">

        DELEGADOS A ELEGIR:<strong>{{ this.delegados }}</strong><br>
        V. EMITIDOS:<strong>{{ this.votos_emitidos }}</strong><br>
        V. BLANCO :<strong>{{ this.votos_blanco }}</strong><br>
        V. NULOS  :<strong>{{ this.votos_nulos }}</strong><br>
        V. VALIDOS:<strong>{{ this.votos_validos }}</strong><br>
         CINCO % :<strong>{{ this.cinco_porciento }}</strong><br>
              </div>
    </div>

  <div class="row" v-if="this.hay_no_cinco_porciento">
    <div class="col-12">
      <div class="info-box bg-danger">
       <h4>CANDIDATURA CON MENOS DEL 5%</h4>
      </div>
    </div>
    <div class="col-12 table-responsive">
      <table class="table table-striped">
        <thead>
        <tr>
          <th>Sind.</th>
          <th>Votos</th>
          <th>%</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="no in this.no_cinco_porciento">
          <td>{{ no[0] }}</td>
          <td>{{ no[1] }}</td>
          <td>{{ no[2] }}</td>
        </tr>

        </tbody>
      </table>
    </div>

  </div>


  <!-- Table row -->
  <div class="row">
    <div class="col-12">
      <div class="card card-primary">
        <div class="card-header">
        <h4>CANDIDATURAS CON MAS DEL 5% DE LOS VOTOS</h4>
        </div>
        <div class="card-body">
       Votos para asignación:<strong>{{ this.votos_para_asignacion }}</strong><br>
        Cociente:<strong>{{ this.cociente }}</strong><br>
        </div>
      </div>
    </div>
      <div class="col-12 table-responsive">
      <table class="table table-striped">
        <thead>
        <tr>
          <th>Sind.</th>
          <th>Votos</th>
          <th>%</th>
          <th>Calculo</th>
          <th>Resto</th>
          <th>Del. C</th>
          <th>Asig.Restos</th>
          <th>Total</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="dc in this.delegados_calculados">
          <td>{{dc["sindicato"]}}</td>
          <td>{{dc["votos"]}}</td>
          <td>{{dc["porcentaje"]}}</td>
          <td>{{dc["calculos"]}}</td>
          <td>{{ dc["restos"]}}</td>
          <td>{{ dc["delegados_completos"]}}</td>
          <td>{{ dc["asignados_por_restos"]}}</td>
          <td>{{parseInt(dc["delegados_completos"])+ parseInt(dc["asignados_por_restos"])}}</td>
        </tr>
        </tbody>
      </table>
    </div>

    <div class="row" v-if="this.repartir_por_antiguedad > 0">
        <div class="col-12 bg-orange">
                Hay que repartir  {{this.repartir_por_antiguedad}} delegad@/s por antigüedad, ya que coinciden los restos de varios sindicatos.<br>
                Se debe revisar el censo y comprobar la antigüedad de los candidatos en la posición correspondiente de la lista.
        </div>
    </div>









</div>


<FormKit
    type="button"
    @click="introduceDatos"
    >
   Volver a intruducir datos
  </FormKit>

</div>







</template>


<script>
import { throwStatement } from '@babel/types';


export default {
        name: 'Calculadora',
        data() {
            return {
            visible:1,
            delegados:1,
            votos_emitidos : 0,
            votos_blanco:0,
            votos_nulos:0,
            candidaturas:[{ sindicato: 'uso', votos: '0' }],
            delegados_calculados:[],
            repartir_por_antiguedad:0,
            cociente:0,
            votos_para_asignacion:0,
            no_cinco_porciento:[],
            cinco_porciento:0,
            votos_validos:0,
            hay_no_cinco_porciento:0


        };
    },

        methods: {

    addCandidatura: function() {
      this.candidaturas.push({ sindicato: '',votos:'' });
            },
    introduceDatos: function() {
      this.visible=1
            },

    deleteCandidatura: function(index) {
      this.candidaturas.splice(index, 1);
        if(index===0)
           this.addCandidatura()
    },
    calculaResultados:function(){
        console.log('entro a enviar por axios')

        axios.post("/calculadora/resultados", {
          csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
          delegados: this.delegados,
          votos_emitidos: this.votos_emitidos,
          votos_blanco: this.votos_blanco,
          votos_nulos:this.votos_nulos,
          candidaturas:this.candidaturas

        })
        .then(
            function (response) {

                this.delegados_calculados = response.data.delegados_calculados,
                this.delegados=response.data.delegados,
                this.votos_emitidos=response.data.votos_emitidos,
                this.votos_blanco=response.data.blancos,
                this.votos_nulos=response.data.nulos,
                this.repartir_por_antiguedad=response.data.repartir_por_antiguedad,
                this.cociente=response.data.cociente,
                this.votos_para_asignacion=response.data.votos_para_asignacion,
                this.no_cinco_porciento=response.data.no_cinco_porciento,
                this.cinco_porciento=response.data.cincoporciento,
                this.votos_validos=response.data.votos_validos,
                this.hay_no_cinco_porciento=response.data.hay_no_cinco_porciento
                this.visible=0
          }.bind(this),



          )

         .catch(function (error) {
            this.visible=1
            alert('Revise los votos tiene que ser enteros, y la suma de todos igual a los votos emitidos')
        }.bind(this))


    }

  },
}




</script>




